import { render, staticRenderFns } from "./AddProjectFeedback.vue?vue&type=template&id=953b4e14&"
import script from "./AddProjectFeedback.vue?vue&type=script&lang=js&"
export * from "./AddProjectFeedback.vue?vue&type=script&lang=js&"
import style0 from "./AddProjectFeedback.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports